import { render } from "./create.vue?vue&type=template&id=38d5e9a4"
import script from "./create.vue?vue&type=script&lang=js"
export * from "./create.vue?vue&type=script&lang=js"
script.render = render

export default script